import axios from "axios";


import { get_video_info, handleEXT, coverIMG } from "./video_article";

export async function get_moreVideo(channelId) {
    const config = {
        method: 'get',
        url: `https://yxwpubmod.hntv.tv/mobile/cms/articles?channelId=${channelId}&tenantId=hnr&pageNo=1&pageSize=20`,
        headers: {}
    };

    try {
        const { data } = await axios(config);
        // 成功获取
        if (data.code == 0) {
            // 开始处理数据
            const temp = [];
            for (const item of data.result.content) {

                // 这个是防止推荐视频重复，判断一下id是否相同
                if (item.id == window.article_info.id) {
                    continue;
                } else {
                    temp.push({
                        id: item.id,
                        title: item.title,
                        des: item.summary,
                        channelId: window.article_info.channelId,
                        url: get_video_info(item),
                        clicknum: item.clickNum,
                        poster: coverIMG(item.coverImagesList),
                        headerimg: handleEXT(item.extFieldsList, '头像', ''),
                        jianjielink: handleEXT(item.extFieldsList, '简介链接', ''),
                        sharetext: handleEXT(item.extFieldsList, '分享文本', ''),
                        from: handleEXT(item.extFieldsList, '创作者', '映象网'),
                        publishDate:item.publishDate
                    })
                }
            }

            return temp;

        } else {
            alert('网络链接有些问题！2')
        }

    } catch (error) {
        alert('网络链接有些问题！')
    }

}